module.exports = __webpack_public_path__ + "static/media/console-M.inline.ea1b44db.svg";